import { FETCH_WORK, FAILED_WORK } from '../actions';

const initialState = {
    fetched: false,
    failed: false,
    posts: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WORK:
            return { ...state, fetched: true, posts: action.payload };
        case FAILED_WORK:
            return { ...state, failed: true };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/work_reducer.jsx